import * as actionTypes from '../store/action';

const initialState = {
    blog: {},
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.BLOG_DATA:
            return {
                ...state,
                blog: action.blogData
            }
        default:
            return state;
    }
}

export default reducer;